//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import InputField from './fields/InputField.vue';
import TextField from './fields/TextField.vue';
import SelectField from './fields/SelectField.vue';
import FileField from './fields/FileField.vue';
import MultiCheckboxField from './fields/MultiCheckboxField.vue';
export default {
  name: 'Profiel',
  components: {
    InputField,
    TextField,
    SelectField,
    FileField,
    MultiCheckboxField,
  },
  props: {
    expert: String,
    ajax: String,
  },
  data: function () {
    return {
      loading: true,
      success: false,
      error: false,
      option_topics: [],
      option_softwares: [],
      option_language: [
        { value: 'nl', label: 'Nederlands' },
        { value: 'gb', label: 'Engels' },
        { value: 'de', label: 'Duits' },
        { value: 'es', label: 'Spaans' },
      ],
      name: {
        value: '',
        error: '',
      },
      professional_headline: {
        value: '',
        error: '',
      },
      content: {
        value: '',
        error: '',
      },
      topic: {
        value: '',
        error: '',
      },
      software: {
        value: [],
        error: '',
      },
      youtube: {
        value: '',
        error: '',
      },
      avatar: {
        value: '',
        error: '',
      },
      language: {
        value: '',
        error: '',
      },
    };
  },
  methods: {
    getProfiel: function () {
      this.loading = true;
      axios.get(`${this.ajax}?action=current_profiel`).then(res => {
        const profiel = res.data;
        console.log(profiel);

        this.name.value = profiel.name;
        // this.content.value = profiel.content;
        this.content.value = profiel.content;
        this.youtube.value = profiel.youtube;
        this.professional_headline.value = profiel.professional_headline;
        this.topic.value = (profiel.topic ? {
          label: profiel.topic.name,
          code: profiel.topic.term_id,
        } : '');
        if (profiel.software && profiel.software.length > 0) {
          this.software.value = profiel.software.map(software => {
            return software.term_id;
          });
        }
        if (profiel.language && profiel.language.length > 0) {
          this.language.value = profiel.language;
          console.log(profiel.language);
        }
        this.avatar.value = [
          {
            source: profiel.avatar.url,
            options: {
              metadata: {
                id: profiel.avatar.id,
              },
            },
          },
        ];
        this.loading = false;
      }).catch(error => {
        console.log(error);
        this.loading = false;
      });
    },
    handleSubmit: function (e) {
      e.preventDefault();

      this.loading = true;

      this.success = false;
      this.error = false;

      const { name, content, youtube, professional_headline, topic, software, language, avatar } = this;

      if (name.value == '') {
        name.error = 'Titel is verplicht.';
        this.error = true;
      } else {
        name.error = '';
      }

      if (professional_headline.value == '') {
        professional_headline.error = 'Professionele headline is verplicht.';
        this.error = true;
      } else if (professional_headline.value.length > 60) {
        professional_headline.error = 'Professionele headline is te lang.';
        this.error = true;
      } else {
        professional_headline.error = '';
      }

      if (content.value == '') {
        content.error = 'Beschrijving is verplicht.';
        this.error = true;
      } else if (content.value.length > 2250) {
        content.error = 'Beschrijving is te lang.';
        this.error = true;
      } else {
        content.error = '';
      }

      if (topic.value == '') {
        topic.error = 'Vakgebied is verplicht.';
        this.error = true;
      } else {
        topic.error = '';
      }

      if (software.value.length <= 0) {
        software.error = 'Software is verplicht.';
        this.error = true;
      } else {
        software.error = '';
      }

      if (language.value.length <= 0) {
        language.error = 'Taal is verplicht.';
        this.error = true;
      } else {
        language.error = '';
      }

      if (avatar.value.length !== 1) {
        avatar.error = 'Profiel foto is verplicht.';
        this.error = true;
      } else {
        avatar.error = '';
      }

      if (this.error) {
        this.loading = false;
        return false;
      }

      const avatar_meta = avatar.value[0].getMetadata();
      const avatar_data = {
        'id': avatar_meta.id ? avatar_meta.id : null,
        'filenameWithoutExtension': avatar.value[0].filenameWithoutExtension,
        'fileExtension': avatar.value[0].fileExtension,
        'fileType': avatar.value[0].fileType,
        'fileSize': avatar.value[0].fileSize,
        'filename': avatar.value[0].filename,
        'data': avatar.value[0].getFileEncodeBase64String(),
      };

      const formData = new FormData();
      formData.append('name', name.value);
      formData.append('content', content.value);
      formData.append('professional_headline', professional_headline.value);
      formData.append('topic', topic.value.code);
      formData.append('software', software.value);
      formData.append('language', language.value)
      console.log('lang: ' + language.value);
      formData.append('youtube', youtube.value);
      formData.append('avatar', JSON.stringify(avatar_data));

      axios({
        method: 'post',
        url: `${this.ajax}?action=update_profiel`,
        data: formData,
        headers: {
          'Content-type': 'application/json',
        },
      }).then(() => {
        this.loading = false;
        this.success = true;
      }).catch(() => {
        this.loading = false;
        this.error = true;
      });
    },
  },
  created: function () {
    axios.get(`${this.ajax}?action=profiel_topics_softwares`).then(res => {
      const { topics, softwares } = res.data;
      this.option_topics = topics.map(topic => {
        return {
          label: topic.name,
          code: topic.term_id,
        };
      });
      this.option_softwares = softwares.map(software => {
        return {
          label: software.name,
          value: software.term_id,
        };
      });
      this.loading = false;
      this.getProfiel();
    }).catch(() => {
      this.loading = false;
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/Profiel.vue